// extracted by mini-css-extract-plugin
export default {"addNoteInput":"NoteInput_addNoteInput__HgFIw","addNoteWrap":"NoteInput_addNoteWrap__n-UKG","noteInput":"NoteInput_noteInput__b+qr4","addNoteButton":"NoteInput_addNoteButton__rKm4a"};